import { reportModuleLoadError } from './browserErrors'

const MODULE_ERROR = /Failed to fetch dynamically imported module|Importing a module script failed|Unable to preload CSS|Loading (?:CSS )?chunk .* failed/i

// 레이아웃 자체를 불러오지 못해도 기존 입력 화면 위에서 복구 안내를 표시한다.
export function installModuleRecovery(app, router, navigate = path => window.location.assign(path)) {
  const previous = app.config.errorHandler
  let dialog
  let focusBefore
  let target = window.location.pathname + window.location.search + window.location.hash
  const dismiss = () => {
    dialog?.remove()
    dialog = undefined
    focusBefore?.focus?.()
  }
  const show = (error, to) => {
    if (!MODULE_ERROR.test(String(error?.message || error || ''))) return
    if (!dialog) {
      target = to?.fullPath?.startsWith('/') && !to.fullPath.startsWith('//')
        ? to.fullPath : window.location.pathname + window.location.search + window.location.hash
    }
    reportModuleLoadError(error, target)
    if (dialog) return
    focusBefore = document.activeElement
    dialog = document.createElement('div')
    dialog.className = 'module-recovery'
    dialog.setAttribute('role', 'alertdialog')
    dialog.setAttribute('aria-modal', 'true')
    dialog.setAttribute('aria-labelledby', 'module-recovery-title')
    const panel = document.createElement('section')
    const title = document.createElement('h2')
    title.id = 'module-recovery-title'
    title.textContent = '화면을 불러오지 못했습니다'
    const message = document.createElement('p')
    message.textContent = '네트워크 상태를 확인한 뒤 다시 열어 주세요. 다시 열면 저장하지 않은 입력 내용이 사라질 수 있습니다.'
    const actions = document.createElement('div')
    const cancel = document.createElement('button')
    cancel.type = 'button'
    cancel.dataset.moduleDismiss = ''
    cancel.textContent = '현재 화면 유지'
    cancel.onclick = dismiss
    const reload = document.createElement('button')
    reload.type = 'button'
    reload.dataset.moduleReload = ''
    reload.textContent = '화면 다시 열기'
    reload.onclick = () => { dismiss(); navigate(target) }
    actions.append(cancel, reload)
    panel.append(title, message, actions)
    dialog.append(panel)
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') dismiss()
      if (event.key === 'Tab') {
        event.preventDefault()
        ;(document.activeElement === cancel ? reload : cancel).focus()
      }
    })
    document.body.append(dialog)
    cancel.focus()
  }
  const onRejection = event => show(event.reason)
  const onError = event => show(event.error || event.message)
  const vueHandler = (error, instance, info) => {
    try { previous?.(error, instance, info) } finally { show(error) }
  }
  const stopRouter = router.onError(show)
  app.config.errorHandler = vueHandler
  window.addEventListener('unhandledrejection', onRejection)
  window.addEventListener('error', onError)
  return () => {
    stopRouter?.()
    dismiss()
    window.removeEventListener('unhandledrejection', onRejection)
    window.removeEventListener('error', onError)
    if (app.config.errorHandler === vueHandler) app.config.errorHandler = previous
  }
}
